import * as ACTION_TYPES from './actionTypes';

const initialState = {
  markers: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.AT_DOJOMAP_GET_DOJOS_SUCCESS:
    {
      return {
        ...state,
        markers: action.dojos
      };
    }
    case ACTION_TYPES.AT_DOJOMAP_GET_DOJOS_FAILURE:
    default:
      return state;
  }
};
